export default __webpack_public_path__ + "static/media/joga_pro_negativo.7606e939.png";